// extracted by mini-css-extract-plugin
module.exports = {"container":"_3QTNK1q6bRVk7rRdp2S0-E","text":"_28gTfGK46F9QXpCjS8mpJZ"};